import * as Styles from './home.styles';
import React from 'react';

export const Home: React.FC = () => {
    return (
      <Styles.HomeContainer>
        <Styles.Title>London Rust Project Group</Styles.Title>
        <Styles.MissionStatement>
          Born out of applying Rust to surgical robotics at King's College London, we provide practical and educational
          support for Rust projects.
        </Styles.MissionStatement>
        <Styles.PartnersSection>
          <Styles.SectionTitle>Our Partners</Styles.SectionTitle>
          <Styles.LogosContainer>
            <a href="https://rapidrecast.io/" target="_blank" rel="noopener noreferrer">
                <Styles.Logo width="200px" src="rapid_recast.png" alt="rapid-recast" />
            </a>
            <a href="https://openuk.uk/" target="_blank" rel="noopener noreferrer">
                <Styles.Logo width="200px" src="open_uk.png" alt="open-uk" />
            </a>
            <a href="https://surrealdb.com/" target="_blank" rel="noopener noreferrer">
                <Styles.Logo width="200px" src="SurrealDB1.png" alt="surrealdb" />
            </a>
            <a href="https://www.lextego.com/" target="_blank" rel="noopener noreferrer">
                <Styles.Logo width="170px" src="lex_tego.png" alt="lex-tego" />
            </a>
          </Styles.LogosContainer>
        </Styles.PartnersSection>
      </Styles.HomeContainer>
    );
  };
